import 'styles/application/modals/_subscription-commitment.scss';

import React from 'react';

import Button from 'components/Button';
import { TranslatedMessage } from 'common/components/Intl';

export default class CommitmentExemptionBuyButton extends React.Component {
  handleClick = () => {
    this.props.addToCart(this.props.sku);
  };

  render() {
    const { canAddCommittableItem } = this.props;

    return (
      <div>
        <Button.KeyAction
          onClick={this.handleClick}
          disabled={!canAddCommittableItem}
          className="CommitmentExemptionBuyButton"
        >
          <TranslatedMessage
            id={'cart.subscription_commit_button.add_to_cart'}
          />
        </Button.KeyAction>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/CommitmentExemptionBuyButton.js